import React from "react";
import Welcome from "../../screens/auth/Welcome";
import type { Meta, StoryObj } from "@storybook/react";

const StoryComponent = () => {
    /* @ts-expect-error Component need a complex navigation handler */
    return <Welcome />;
};

const meta = {
    title: "Screens/Welcome",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
